let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("dxx5D")).then(() => parcelRequire('e0i7w'));